// extracted by mini-css-extract-plugin
export default {"wrapper":"rD-z","viewport":"sD-z","container":"tD-z","slide":"uD-z"};